module.exports = __webpack_public_path__ + "img/white-and-yellow-with-subtitle.8ab2479d.png";